export const ENCODING_VALIDATION_MESSAGE = {
  encoded: 'Encoded',
  invalidVideoCodec: 'Video should be encoded with',
  invalidAudioCodec: 'Audio should be encoded with',
  videoStreamNotAvailable: 'Video stream not available',
  audioStreamNotAvailable: 'Audio stream not available',
};
